import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError, AxiosResponse } from 'axios'
import { fetchDataFromApi } from '../services/fetchDataFromApi.tsx'

interface AppState {
  adrNo: string
  selectedDocIdx: number | undefined
  loading: 'idle' | 'pending' | 'succeeded' | 'failed'
  error: string | null
  statusCode: number | null
}

interface FetchApiDataOptions {
  url: string
  token: string
  method?: string
}

const initialState: AppState = {
  adrNo: '',
  selectedDocIdx: undefined,
  loading: 'idle',
  error: null,
  statusCode: null,
}

// Dozenten ID per Adress Nr holen
export const fetchDocentIdByAdressNr = createAsyncThunk('api/fetchDocentIdByAdressNr', async ({ url, token }: FetchApiDataOptions) => {
  try {
    const data: AxiosResponse | AxiosError = await fetchDataFromApi(url, token)
    return data
  } catch (error: any) {
    // Fehlerbehandlung
  }
})

const appSlice = createSlice({
  name: 'appStore',
  initialState,
  reducers: {
    setAddressNr: (state, action) => {
      state.adrNo = action.payload
    },
    clearAddressNr: (state) => {
      state.adrNo = ''
    },
    setSelectedDocentId: (state, action) => {
      state.selectedDocIdx = action.payload
    },
    clearSelectedDocentId: (state) => {
      state.selectedDocIdx = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      // Dozenten ID per Adress Nr holen
      .addCase(fetchDocentIdByAdressNr.pending, (state) => {
        state.loading = 'pending'
      })
      .addCase(fetchDocentIdByAdressNr.fulfilled, (state, action) => {
        const result = action.payload
        if (result instanceof AxiosError) {
          if (result?.status < 200 || result.status >= 300) {
            state.statusCode = result.status
          } else if (result.code === 'ERR_NETWORK') {
            state.statusCode = 503
          } else if (result.code === 'ERR_BAD_REQUEST') {
            state.statusCode = 403
          } else {
            state.statusCode = result.status
          }
          state.loading = 'failed'
          state.error = result.statusText
        } else if (result) {
          state.loading = 'succeeded'
          state.selectedDocIdx = action.payload?.data
          state.statusCode = result.status
        }
      })
      .addCase(fetchDocentIdByAdressNr.rejected, (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message || 'An error occurred'
      })
  },
})

export const { setAddressNr, setSelectedDocentId, clearSelectedDocentId, clearAddressNr } = appSlice.actions

export default appSlice.reducer
